import request from '@/libs/request'

//生产加工 列表
export function plantProductionListApi (data) {
  return request({
    url: `plant/plantProduction`,
    method: 'get',
    params: data
  })
}

//生产加工 详情
export function plantProductionInfoApi (id) {
  return request({
    url: `plant/plantProduction/` + id,
    method: 'get'
  })
}


//生产加工 编辑/添加
export function plantProductionSaveApi (data) {
  return request({
    url: `plant/plantProduction`,
    method: 'post',
    data: data
  })
}

//生产加工 删除
export function plantProductionDelApi (id) {
  return request({
    url: `plant/plantProduction/` + id,
    method: 'delete'
  })
}

// 生产加工 所有
export function plantProductionAllApi (data = {}) {
  return request({
    url: `plant/plantProductionApi/all`,
    method: 'get',
    params: data
  })
}

// 生产加工 下载溯源码
export function plantProductionDownloadQrCodeApi(id) {
  return request({
    url: `plant/plantProductionApi/traceabilityCode/${id}`,
    method: 'get',
    responseType: 'blob',
  })
}

// 生产加工 切换溯源状态
export function plantProductionChangeShowSourceApi (id) {
  return request({
    url: `plant/plantProductionApi/changeShowSource/` + id,
    method: 'post',
  })
}

// 生产加工 溯源产品介绍 保存
export function plantProductionSourceSaveApi (data) {
  return request({
    url: `plant/plantProductionApi/sourceSave`,
    method: 'post',
    data: data
  })
}

